import * as utils from 'global/common/globalUtils';

const BEM_BLOCK = `product-price-table`;
const PRICE_TABLE_ROW_CLASS = `${BEM_BLOCK}__row`;
const IS_ACTIVE_PRICE_ROW_CLASS = `${BEM_BLOCK}__row--is-active`;
const PRICES_QUANTITY_CLASS = `${BEM_BLOCK}__volume-prices-quantity`;
export default class ProductPriceTable {
	constructor() {
		this.subscribeEvents();
		this.addClickListener();
		this.addKeyupListener();
	}

	subscribeEvents() {
		window.od.events.subscribe(
			'quantityInput_QtyChanged',
			this.syncActiveRowToPublishedQty.bind(this),
		);
		window.od.events.subscribe(
			'addToCart_QtyReset',
			this.syncActiveRowToPublishedQty.bind(this),
		);
		window.od.events.subscribe(
			'productPriceTable_RowSelected',
			this.rowClicked.bind(this),
		);
	}

	syncActiveRowToPublishedQty({ articleNumber, qty }) {
		this.removeCurrentActiveRowState(articleNumber);
		this.makePriceRowsActiveOnChangeEvent(articleNumber, qty);
	}

	rowClicked({ articleNumber, rowIndex }) {
		this.removeCurrentActiveRowState(articleNumber);
		this.addNewActiveRowState(articleNumber, rowIndex);
	}

	removeCurrentActiveRowState(articleNumber) {
		const selector = `.product-price-table[data-article-number="${articleNumber}"] .${IS_ACTIVE_PRICE_ROW_CLASS}`;
		const activeRows = document.querySelectorAll(selector);
		activeRows.forEach(row => row.classList.remove(IS_ACTIVE_PRICE_ROW_CLASS));
	}

	forEachPriceTableRow(articleNumber, callback) {
		const tables = document.querySelectorAll(
			`.product-price-table[data-article-number="${articleNumber}"]`,
		);
		tables.forEach(table => {
			const rows = table.querySelectorAll(`.${PRICE_TABLE_ROW_CLASS}`);
			callback(rows, table);
		});
	}

	addNewActiveRowState(articleNumber, rowIndex) {
		this.forEachPriceTableRow(articleNumber, rows => {
			const row = rows[rowIndex];
			if (row) {
				row.classList.add(IS_ACTIVE_PRICE_ROW_CLASS);
			}
		});
	}

	makePriceRowsActiveOnChangeEvent(articleNumber, qty) {
		this.forEachPriceTableRow(articleNumber, rows => {
			rows.forEach(row => this.makePriceRowActiveOnChangeEvent(row, qty));
		});
	}

	makePriceRowActiveOnChangeEvent(row, qty) {
		const quantityEl = row.querySelector(`.${PRICES_QUANTITY_CLASS}`);
		if (!quantityEl) return;

		const rowMinQuantity = Number(quantityEl.dataset.minQuantity);
		const rowMaxQuantity = Number(quantityEl.dataset.maxQuantity);

		const withinMin = qty >= rowMinQuantity;
		const withinMax = !rowMaxQuantity || qty <= rowMaxQuantity;

		if (withinMin && withinMax) {
			row.classList.add(IS_ACTIVE_PRICE_ROW_CLASS);
		}
	}

	addClickListener() {
		document.body.addEventListener('click', e => {
			this.publishRowClickedEvent(e);
		});
	}

	addKeyupListener() {
		document.body.addEventListener('keyup', e => {
			if (
				e.key === 'Enter' &&
				document.activeElement.classList.contains(PRICE_TABLE_ROW_CLASS)
			) {
				this.publishRowClickedEvent(e);
			}
		});
	}

	publishRowClickedEvent(e) {
		const row = e.target.closest(`.${PRICE_TABLE_ROW_CLASS}`);
		if (!row) return;

		const table = row.closest(`.${BEM_BLOCK}`);
		if (!table) return;

		const quantityEl = row.querySelector(`.${PRICES_QUANTITY_CLASS}`);
		if (!quantityEl) return;

		const { minQuantity } = quantityEl.dataset;
		const { articleNumber } = table.dataset;

		const syncId = table.dataset.syncId || utils.generateSyncId(table);

		const rows = Array.from(
			table.querySelectorAll(`.${PRICE_TABLE_ROW_CLASS}`),
		);
		const rowIndex = rows.indexOf(row);

		window.od.events.publish('productPriceTable_RowSelected', {
			articleNumber,
			qty: minQuantity,
			rowIndex,
			syncId,
		});
	}
}
